var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({staticClass:"ma-0",attrs:{"menu-props":{ bottom: true, offsetY: true },"item-value":"id","item-text":"name","return-object":""}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }